import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { homePathForUser, LOGIN_PATH } from './RoleHomeRedirect';
import { Brand } from '../components/Brand';
import { errorMessageFor } from './error-message';

/**
 * `/`'s login form (spec: "Entrada" / "Lenguaje visual"): a centered dark
 * panel on a near-black background, HAMMER brand, email + password only — no role
 * selector, since the server is the only authority for role. Submits once,
 * disables the button while the request is in flight, and shows the API's
 * own safe message on failure.
 */
export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    if (submitting) return;
    setError('');
    setSubmitting(true);
    try {
      const user = await login(email, password);
      // Unknown roles have no home: land on `/`, where the entry route shows
      // the shared unavailable screen instead of leaving this form stuck.
      navigate(homePathForUser(user) || LOGIN_PATH, { replace: true });
    } catch (caught) {
      setError(errorMessageFor(caught));
      setSubmitting(false);
    }
  }

  return (
    <main className="gym-entry">
      <div className="gym-entry__panel">
        <h1 className="gym-entry__brand">
          <Brand tone="light" size="lg" />
        </h1>
        <p className="gym-entry__lead">Ingresá con tu email y tu contraseña.</p>
        <form className="gym-form" onSubmit={handleSubmit} noValidate>
          {error && (
            <p role="alert" className="gym-form__error">{error}</p>
          )}

          <div className="gym-field">
            <label htmlFor="login-email" className="gym-field__label">Email</label>
            <input
              id="login-email"
              name="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              disabled={submitting}
              onChange={(event) => setEmail(event.target.value)}
              className="gym-input"
            />
          </div>

          <div className="gym-field">
            <label htmlFor="login-password" className="gym-field__label">Contraseña</label>
            <input
              id="login-password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              disabled={submitting}
              onChange={(event) => setPassword(event.target.value)}
              className="gym-input"
            />
          </div>

          <button type="submit" disabled={submitting} className="gym-button gym-button--primary gym-button--block">
            {submitting ? 'Ingresando…' : 'Ingresar'}
          </button>
        </form>
      </div>
    </main>
  );
}
